module.exports = __webpack_public_path__ + "media/src/images/icons/printer-3b42163e8f5634540454d08b9e7e7b54.svg";